import { Box, TextField } from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';
import * as React from 'react';

import { useLoggedInEmployeeId } from '~/components/Auth';
import { useSelectedEmployeeContext } from '~/components/SelectedEmployee';

type EmpIdSelectorProps = {
  render: (employeeId: number) => ReactNode;
  syncSelectedEmployeeId?: boolean;
};

export const LibTestEmpIdSelector = (props: EmpIdSelectorProps) => {
  const { render, syncSelectedEmployeeId } = props;

  const loggedInId = useLoggedInEmployeeId();
  const { selectedEmployeeId, setSelectedEmployeeId } =
    useSelectedEmployeeContext();
  const [value, setValue] = useState<number>(loggedInId);

  useEffect(() => {
    if (selectedEmployeeId !== value && syncSelectedEmployeeId) {
      setSelectedEmployeeId(value);
    }
  }, [
    value,
    selectedEmployeeId,
    setSelectedEmployeeId,
    syncSelectedEmployeeId,
  ]);

  return (
    <Box>
      <Box
        sx={{
          position: 'absolute',
          right: 0,
          bottom: 0,
        }}
      >
        <TextField
          type={'number'}
          value={value}
          onChange={(event) => {
            const eId = parseInt(event.target.value);
            if (!isNaN(eId)) {
              setValue(eId);
            } else {
              setValue(loggedInId);
            }
          }}
        />
      </Box>

      {render(value)}
    </Box>
  );
};
